import { render, staticRenderFns } from "./delivered_mr.vue?vue&type=template&id=1a5b0327&"
import script from "./delivered_mr.vue?vue&type=script&lang=js&"
export * from "./delivered_mr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports